"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRectElementwise = void 0;
var updateRectElementwise = function (from, updateFn) {
    return from.withMutations(function (rect) {
        return rect
            .update('top', updateFn)
            .update('left', updateFn)
            .update('width', updateFn)
            .update('height', updateFn);
    });
};
exports.updateRectElementwise = updateRectElementwise;
